var map = {
	"./en/common.json": 34010,
	"./en/screen.json": 46660,
	"./en/web.json": 14425,
	"./zh-cn/common.json": 64249,
	"./zh-cn/screen.json": 41164,
	"./zh-cn/web.json": 36421
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68262;